interface Recipient {
  id: number;
  name: string;
  relationship: string;
}

interface RecipientsNavigationProps {
  recipients: Recipient[];
  selectedRecipient: number | null;
  onRecipientSelect: (recipientId: number) => void;
}

export function RecipientsNavigation({ recipients, selectedRecipient, onRecipientSelect }: RecipientsNavigationProps) {
  return (
    <div
      className="bg-bg-cream border-b border-gray-200 py-4 sticky top-0 z-10"
      style={{ boxShadow: '0px 4px 20px 0px rgba(21, 93, 226, 0.14)' }}
    >
      <div className="max-w-[1240px] mx-auto px-4">
        <div className="flex items-center space-x-1">
          <span className="text-purple-medium text-2xl font-light mr-4">Gifts for</span>
          {recipients.map((recipient) => (
            <div key={recipient.id} className="flex items-center">
              <button
                onClick={() => onRecipientSelect(recipient.id)}
                className={`px-4 py-2 rounded-full text-sm font-medium transition-all cursor-pointer ${
                  selectedRecipient === recipient.id
                    ? 'bg-purple-medium text-white'
                    : 'text-purple-medium hover:bg-purple-light hover:text-white'
                }`}
              >
                {recipient.name}
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
